import { useState } from "react";
import { toast } from "sonner";
import { Modal, Button } from "react-bootstrap";
import { DeleteAccount } from '../service/api/DeleteAccount';

const DeleteAccountButton = ({ accountId, accountTypeName, onDeleteSuccess }) => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      await DeleteAccount(accountId);
      toast.success("Le compte a été supprimé avec succès!", {
        position: "top-center",
      });
      onDeleteSuccess(accountId, accountTypeName);
      handleClose();
    } catch (error) {
      toast.error("Erreur lors de la suppression du compte.", {
        position: "top-center",
      });
      setLoading(false);
    }
  };

  return (
    <>
      {/* Remplacer <button> par un élément <div> ou <span> avec role="button" */}
      <li>
        <div
          role="button"
          tabIndex={0}
          className="dropdown-item"
          onClick={handleShow}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              handleShow();
            }
          }}
          style={{ cursor: 'pointer' }}
        >
          <i className="fas fa-trash3" />
          Supprimer
        </div>
      </li>

      {/* Modale de confirmation */}
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmer la suppression</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Êtes-vous sûr de vouloir supprimer ce compte ? Cette action est irréversible.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Non
          </Button>
          <Button
            variant="danger"
            onClick={handleDelete}
            disabled={loading}
          >
            {loading ? "Suppression..." : "Oui"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DeleteAccountButton;